export const GET_CARD_OPERATION_FEES_START =
  'GET_CARD_OPERATION_FEES_START';
export const GET_CARD_OPERATION_FEES_SUCCESS =
  'GET_CARD_OPERATION_FEES_SUCCESS';
export const GET_CARD_OPERATION_FEES_ERROR =
  'GET_CARD_OPERATION_FEES_ERROR';
export const GET_CARD_OPERATION_FEES_END =
  'GET_CARD_OPERATION_FEES_END';
